import {
  CHANNEL_FETCH_REQUEST,
  CHANNEL_FETCH_REQUEST_SUCCESS,
  CHANNEL_FETCH_REQUEST_FAILURE,
  CHANNEL_ADD_REQUEST,
  CHANNEL_ADD_REQUEST_SUCCESS,
  CHANNEL_ADD_REQUEST_FAILURE,
  CHANNEL_UPDATE_REQUEST,
  CHANNEL_UPDATE_REQUEST_SUCCESS,
  CHANNEL_UPDATE_REQUEST_FAILURE,
  CHANNEL_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const channelsReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case CHANNEL_FETCH_REQUEST:
    case CHANNEL_ADD_REQUEST:
    case CHANNEL_UPDATE_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case CHANNEL_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.pageSize,
          total: action.data.totalRecord,
          totalPage: action.data.totalPage,
          showSizeChanger: true,
        },
      });

    case CHANNEL_ADD_REQUEST_SUCCESS:
    case CHANNEL_UPDATE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case CHANNEL_FETCH_REQUEST_FAILURE:
    case CHANNEL_ADD_REQUEST_FAILURE:
    case CHANNEL_UPDATE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case CHANNEL_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });

    default:
      return state;
  }
};

export default channelsReducer;
